import { api } from '@/services'

export function findAll(params) {
  return api.get('/web/recharge', { params })
}
